import MakeIntegrationIcon from "../../../Assets/svgs/MakeIntegrationIcon";
import N8nIntegrationIcon from "../../../Assets/svgs/N8nIntegrationIcon";
import { AutomationToolsData } from "../../../Common/Constants";

const AutomationTools = () => {
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return (
    <div className="tabsContent">
      <div className="details">
        <div className="appsWrap">
          <h1 className="title title--h3">Automation Tools</h1>
          <div className="appsWrap__list">
            {AutomationToolsData.map((item, index) => (
              <div className="appsWrap__list__item" key={index}>
                <div className="appsWrap__card">
                  <div className="titleContainer">
                    <h1 className="title title--h5">
                      <span className="icon">
                        {item?.title == "Make.com" ? (
                          <MakeIntegrationIcon />
                        ) : (
                          <N8nIntegrationIcon />
                        )}
                      </span>
                      {item.title}
                    </h1>
                  </div>
                  <p className="para">{item.details}</p>
                  <div className="btn__group">
                    <button
                      className="btn btn__primary btn--full"
                      disabled={item?.isConnected}
                      onClick={() => openInNewTab(item?.url)}
                    >
                      Open
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomationTools;
